<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:36:31
 * @LastEditTime: 2022-12-24 17:24:32
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/index.vue
 *
-->
<template>
  <div
    class="community_Index"
    :class="{ hasTabbar: routerName == 'communityList' }"
  >
    <keep-alive :include="includes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped>
.community_Index {
  width: 100%;
  background: #f6f6f6;
}
.hasTabbar {
  padding-bottom: 60px;
  height: calc(100% - 60px);
  overflow: scroll;
}
</style>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {
  getCookie,
  getUrlParamsByName,
  is_weixin,
  isUserLogin,
  setCookie,
} from '@/assets/js/common.js'

var hasHandlerInfo = false // 是否初始化用户信息
export default {
  name: 'communityIndex',
  components: {},
  data() {
    return {
      isRecommendSwitch: null, // 是否开启了智能推荐
      UserInfo: {}, // 用户信息
      babyInfo: [],
      optionList: [],
      routerName: 'communityList',
    }
  },
  computed: {
    // 在computed中动态监控
    ...mapState({
      includes: (state) => state.includes,
    }),
    babyNums() {
      return localStorage.getItem('babyNums')
    },
  },
  mounted() {
    // this.shareHome()
    this.$store.commit('changeIncludes', ['communityIndex', 'communityList'])
  },

  created() {
    this.babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    // 获取月龄段
    getMonthsPeriod() {
      this.$http.get('/babyWikiRevision/monthsPeriod', {}, (res) => {
        if (res.code === '200') {
          this.optionList = [{ name: '全部', id: 0 }]
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i])
            }
          }
          const babyNum = localStorage.getItem('babyNums')
          const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
          let id =
            babyInfo && babyInfo.length
              ? babyInfo.filter((item) => item.num == babyNum)[0].tag_id
              : null
          if (id == 1) {
            id = 2
          } else if (id == 2) {
            id = 1
          }
          const data = this.optionList.filter((item) => item.id == id)[0]
          localStorage.setItem('babyBuried', JSON.stringify(data ? data : null))
        }
      })
    },
  },

  watch: {
    babyNums: {
      handler(newValue) {
        alert(newValue)
      },
      deep: true,
    },
    $route: {
      handler(to, from) {
        this.routerName = to.name
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
